import { createFileRoute } from "@tanstack/react-router";
import { ContractsListPage } from "@/features/contracts/contracts-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.definicje",
			location.pathname,
		);
	},
	component: ContractsListPage,
});
